import "./SpecialOffer.css";

import { useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";
import { useTranslation } from "react-i18next";

import type { DetailedSpecialOffer } from "~/core/deprecated/special-offers";

export type Props = {
  specialOffers: Array<DetailedSpecialOffer>;
  featureFlags: {
    isSpecialOffersButtonEnabled: boolean;
  };
};

/**
 * @deprecated
 */
export const SpecialOffers: FC<Props> = (data) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("home");

  const { Link } = useUiKitComponents();

  return (
    <section className="special-offers-section">
      <div className="section-content">
        <div className="header">
          <h2 className="desktop-only">{t("special-offer.heading.title")}</h2>
          <h2 className="mobile-only">
            {t("special-offer.heading.title.mobile")}
          </h2>
          {data.featureFlags.isSpecialOffersButtonEnabled && (
            <Link href="/promotions" className="button show-all-button">
              {t("special-offer.button.show")}
            </Link>
          )}
        </div>
        <ul className="special-offers">
          {data.specialOffers.map((offer, i) => {
            return (
              <li key={i} className="special-offer">
                <Link href={`${offer.url}`}>
                  <img
                    src={offer.image[language]}
                    alt={offer?.name ? offer.name[language] : ""}
                  />
                </Link>
                {offer?.name && (
                  <div className="offer-name">{offer.name[language]}</div>
                )}
              </li>
            );
          })}
        </ul>
        {data.featureFlags.isSpecialOffersButtonEnabled && (
          <div className="footer">
            <Link href="/promotions" className="button show-all-button">
              {t("special-offer.button.show")}
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};
